import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { DespachoComponent } from './despacho.component';
import { ServiciosactivosComponent } from './subdespacho/serviciosactivos/serviciosactivos.component';
import { FromulariodespachoComponent } from './subdespacho/fromulariodespacho/fromulariodespacho.component';
import { EquiposComponent } from './subdespacho/equipos/equipos.component';
import { TagEstadisticasDespachoComponent } from './subdespacho/tag-estadisticas-despacho/tag-estadisticas-despacho.component';
import { DatoserviciosComponent } from './subdespacho/datoservicios/datoservicios.component';
import { PermisosGuard } from 'app/guards/permisos.guard';
import { VerAgendaComponent } from 'app/components/agenda/ver-agenda/ver-agenda.component';


let despachoRoutes:Routes =[
    { path: 'despacho',component:DespachoComponent, children: [
            
            { path: 'servicios-activos', component: ServiciosactivosComponent/* , canActivate:[PermisosGuard], data: { id_permiso: 1 }  */},
            { path: 'form-despacho', component:FromulariodespachoComponent/* , canActivate:[PermisosGuard], data:{id_permiso:2} */},
            { path: 'equipos', component:EquiposComponent/* , canActivate:[PermisosGuard], data:{id_permiso:3} */},
            { path: 'estadisticas', component: TagEstadisticasDespachoComponent/* , canActivate: [PermisosGuard], data: { id_permiso: 3 }  */},
            { path: 'datos-servicios', component:DatoserviciosComponent/* , canActivate:[PermisosGuard], data:{id_permiso:5} */},
            { path: '', redirectTo:'despacho/form-despacho',pathMatch:'full'},
        ]
    }
  ]
@NgModule({
    imports:[RouterModule.forChild(despachoRoutes)]
})
export class DespachoRouterModule{}